import { observable, action } from 'mobx'
import ApiCaller from '../utils/api-caller'

class recommendationStore {

    // Properties

    @observable setupRecommendations = []
    @observable itemRecommendationId = undefined
    @observable categoryItemId = undefined
    @observable subCategoryItemId = undefined
    @observable subCategoryItemName = undefined
    @observable itemId = undefined
    @observable recommendationItemName = undefined
    
    @observable fnbByItemForRecommendations = []
    @observable fnbByItemForRecommendationsFilter = []
    @observable fnbSubCategoryNames = []

    @observable fnbBySubCategoryForRecommendations = []
    @observable fnbBySubCategoryForRecommendationsFilter = []

    @observable showUpdateRecommendationModal = undefined
    @observable showSearchRecommendationModal = false
    @observable showSearchSubCategoryRecommendationModal = false

    @observable itemSearchValue = ''
    @observable isMainItemSelected = false
    @observable isRecommendationItemSelected = false

    @observable manageItemRecommendationTitle = ''
    
    @observable updateLoading = false

    // Initialization

    @action initGetFnbRecommendations() {
        // Get Recommendation Setups
        return ApiCaller.ItemRecommendation.apiGetItemRecommendations().then((recommendationSetupResponses) => {
            this.setupRecommendations = []
            this.setupRecommendations = recommendationSetupResponses

            // Get FnB By Item For Recommendations
            ApiCaller.Item.apiGetFnbRecommendationByItem().then((fnbByItemForRecommendationResponses) => {
                this.fnbByItemForRecommendations = fnbByItemForRecommendationResponses

                let fnbSubCatNames = []

                this.setupRecommendations.map((setupRecommendation) => {
                    let fnbForRecommendations = this.fnbByItemForRecommendations.filter(fi => fi.itemId === setupRecommendation.itemId)
                    if (fnbForRecommendations.length > 0) {
                        fnbForRecommendations[0].selected = true
                        fnbForRecommendations[0].itemRecommendationId = setupRecommendation.itemRecommendationId
                    }

                    if (setupRecommendation.subCategoryItemName !== '') {
                        let isSubCatNameExist = fnbSubCatNames.filter(fi => fi.text === setupRecommendation.subCategoryItemName)

                        if (isSubCatNameExist.length > 0) {
    
                        } else {
                            fnbSubCatNames.push({
                                text: setupRecommendation.subCategoryItemName,
                                value: setupRecommendation.subCategoryItemName
                            })
                        }
                    }

                    return fnbForRecommendations;
                })

                this.fnbSubCategoryNames = fnbSubCatNames
                this.fnbByItemForRecommendationsFilter = this.fnbByItemForRecommendations

                // Get FnB By Sub Category For Recommendations
                ApiCaller.Item.apiGetFnbRecommendationBySubCategory().then((fnbBySubCategoryForRecommendationResponses) => {
                    this.fnbBySubCategoryForRecommendations = fnbBySubCategoryForRecommendationResponses

                    this.fnbSubCategoryNames.map((subcCategoryName) => {
                        let fnbForRecommendations = this.fnbBySubCategoryForRecommendations.filter(fi => fi.subCategoryItemName === subcCategoryName.text);

                        if(fnbForRecommendations.length > 0) {
                            fnbForRecommendations[0].selected = true;
                        }

                        return fnbForRecommendations;
                    })

                    this.fnbBySubCategoryForRecommendationsFilter = this.fnbBySubCategoryForRecommendations

                    this.updateLoading = false
                })
            })
        })
    }

    @action initCreateItemRecommendation() {
        this.manageItemRecommendationTitle = 'Add Item Recommendation'

        this.categoryItemId = 0
        this.itemRecommendationId = 0
        this.subCategoryItemName = ''
        this.itemId = undefined
        this.recommendationItemName = ''

        this.showSearchRecommendationModal = true
    }

    @action initCreateSubCategoryRecommendation() {
        this.manageItemRecommendationTitle = 'Add Category'

        this.showSearchSubCategoryRecommendationModal = true
    }

    // CRUD Action

    @action createItemRecommendation(categoryItemId, subCategoryItemId, itemId) {
        this.updateLoading = true
        return ApiCaller.ItemRecommendation.apiCreateItemRecommendation(categoryItemId, subCategoryItemId, itemId).then(() => {
            this.initGetFnbRecommendations()
        })
    }

    @action deleteItemRecommendation(itemRecommendationId) {
        this.updateLoading = true
        return ApiCaller.ItemRecommendation.apiDeleteItemRecommendation(itemRecommendationId).then(() => {
            this.initGetFnbRecommendations()
        })
    }

    @action selectSubCategoryRecommendation(subCategoryItemId) {
        this.updateLoading = true
        return ApiCaller.ItemRecommendation.apiCreateSubCategoryRecommendation(subCategoryItemId).then(() => {
            this.initGetFnbRecommendations()
        })
    }

    @action deleteSubCategoryRecommendation(subCategoryItemId) {
        return ApiCaller.ItemRecommendation.apiDeleteSubCategoryRecommendation(subCategoryItemId).then(() => {
            this.initGetFnbRecommendations()
        })
    }

    // SET Properties

    @action setItemSearchValue(value) { 
        this.itemSearchValue = value 
    }

    @action setShowSearchRecommendationModal(value) { 
        this.showSearchRecommendationModal = value 
    }

    @action setShowSearchSubCategoryRecommendationModal(value) { 
        this.showSearchSubCategoryRecommendationModal = value 
    }

    @action searchItemInRecommendationOption() {
        this.fnbByItemForRecommendationsFilter = this.fnbByItemForRecommendations.filter(item => {
            let itemName = item.itemName.toLowerCase();
            return itemName.indexOf(this.itemSearchValue.toLowerCase()) !== -1;
        });
    }
}

export default new recommendationStore()